import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'index', component: r => { require(['./views/index'], r) }, meta: { title: 'YES GO' }},
  { path: '/result', name: 'result', component: r => { require(['./views/result'], r) }, meta: { title: 'YES GO' }},
  { path: '/selectTime', name: 'selectTime', component: r => { require(['./views/selectTime'], r) }, meta: { title: 'YES GO' }},
  { path: '/interviewer', name: 'interviewer', component: r => { require(['./views/interviewer'], r) }, meta: { title: 'YES GO' }},
  { path: '/entrance', name: 'entrance', component: r => { require(['./views/entrance'], r) }, meta: { title: 'YES GO' }},
  { path: '/evaluation', name: 'evaluation', component: r => { require(['./views/evaluation'], r) }, meta: { title: 'YES GO' }},
  { path: '/paySucceed', name: 'paySucceed', component: r => { require(['./views/paySucceed'], r) }, meta: { title: 'YES GO' }},
  { path: '/agreement', name: 'agreement', component: r => { require(['./views/agreement'], r) }, meta: { title: 'YES GO' }},
  { path: '/orderPay', name: 'orderPay', component: r => { require(['./views/orderPay'], r) }, meta: { title: 'YES GO' }}
]

export default new VueRouter({
  mode: 'hash',
  scrollBehavior(to, from, savePosition) {
    if (savePosition) {
      return savePosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: routes
})
